import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuarioService } from '../shared/service/usuario/usuario.service';

@Component({
  selector: 'app-redefinicao-email',
  templateUrl: './redefinicao-email.component.html',
  styleUrls: ['./redefinicao-email.component.css']
})
export class RedefinicaoEmailComponent implements OnInit {
  public showSuccessMessage : boolean = false;
  public showErrorMessage : boolean = false;
  constructor(
    private route: ActivatedRoute,
    private usuarioService: UsuarioService,
  ) {
    
   }

  ngOnInit() {
    this.usuarioService.confirmarTrocaDeEmail(this.route.snapshot.params.token).then((userRequest)=> {
      this.showSuccessMessage = true;
      this.showErrorMessage = false;
    }).catch((error) => {
      this.showSuccessMessage = false;
      this.showErrorMessage = true;
    });
  }

}
